// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UpdateEmployeeDeductionInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payroll/update_employee_deduction/{id}
 *
 * Validates input for updating an employee deduction (partial update).
 */
import { registerContract } from './validate'

export interface Payroll_UpdateEmployeeDeductionInput {
title?: string
description?: string
amount?: number
deduction_date?: string
}

registerContract('Payroll_UpdateEmployeeDeductionInput', {
  title:          { type: 'string',  required: false },
  description:    { type: 'string',  required: false },
  amount:         { type: 'number',  required: false },
  deduction_date: { type: 'string',  required: false },
})
